<template lang="html">
    <div class="row">

        <div class="col-sm-12">
            <div class="row">
                <div class="col-sm-12">
                    <label>Start Date</label>
                </div>

                <!-- Cron start date -->
                <div class="col-sm-12">


                    <div class="">
                        <datepicker
                            :disabledPicker="disabledSTartDate"
                            v-model="startDateTreated"
                            :monday-first="false"
                            format="dd-MM-yyyy">
                        </datepicker>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-sm-12 mt-3">

            <div class="row">

                <div class="col-sm-12">
                    <label>Repetition</label>
                </div>

                <div class="col-sm-3">
                    <v-select :options="repetitionOptions" v-model="selectedRepetitionOption" @input="repetitionChanged"></v-select>
                </div>

                <!-- Configure selected CRON type -->
                <div class="col-sm-9">

                    <div class="row">
                        <!-- Weekly -->
                        <div class="col-sm-6 d-flex align-items-center" v-if="selectedRepetitionOption.id == 1">
                            <span class="pr-4">On</span>
                            <v-select :options="weekDayOptions" v-model="selectedWeekDayOption" @input="repetitionChanged"></v-select>
                        </div>

                        <!-- Monthly -->
                        <div class="col-sm-6 d-flex align-items-center" v-if="selectedRepetitionOption.id == 2">
                            <span class="pr-4">On day</span>
                            <v-select :options="monthDayOptions" v-model="selectedMonthDayOption" @input="repetitionChanged"></v-select>
                        </div>
                    </div>

                </div>

            </div>
        </div>


    </div>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import Datepicker from 'vuejs-datepicker';

import vSelect from 'vue-select'

export default {
    created: function () {
        this.cronToVisualConfiguration()
    },
    data: function () {
        return {
            selectedRepetitionOption: {
                label: 'Weekly',
                id: 1
            },
            selectedWeekDayOption: {
                label: 'Monday',
                id: 1,
            },
            selectedMonthDayOption: {
                label: '1',
                id: 1,
            },
        }
    },
    props: {
        cron: {
            type: String,
            default: '0 0 * * 1', // Weekly on monday
        },
        startDate: {
            required: false
        },
        disabledSTartDate:{
            type: Boolean
        }
    },
    computed:{
        ...mapGetters([
            'getRepetitionOptions',
            'getWeekDayOptions',
            'getMonthDayOptions'
        ]),
        startDateTreated: {
            get: function () {
                return this.startDate
            },
            set: function (val) {
                console.log('new val', val);
                this.$emit('update:startDate', moment(val).format('YYYY-MM-DD') + ' 00:00:00')
            }
        },
        repetitionOptions: function () {
            return this.getRepetitionOptions
        },
        weekDayOptions: function () {
            return this.getWeekDayOptions
        },
        monthDayOptions: function () {
            return this.getMonthDayOptions
        },
        cronOutput: function () {
            let cron = null
            switch (this.selectedRepetitionOption.id) {
                case 1: // Weekly
                    cron = `0 0 * * ${this.selectedWeekDayOption.id}`
                    break;
                case 2: // Monthly
                    cron = `0 0 ${this.selectedMonthDayOption.id} * *`
                    break;
                default:
                    cron = false
            }
            return cron
        }
    },
    methods: {
        repetitionChanged: function () {
            this.$emit('update:cron', this.cronOutput)
        },
        cronToVisualConfiguration: function () {
            if(!this.cron){
                return false
            }

            let cronArray = this.cron.split(" ")

            if(cronArray[2] == '*'){
                // its Weekly
                // select repetition "Weekly"
                this.selectedRepetitionOption = this.repetitionOptions.find(repetitionOption => {
                    return repetitionOption.id == 1
                })

                // select week day
                this.selectedWeekDayOption = this.getWeekDayOptions.find(weedayOption => {
                    return weedayOption.id == cronArray[4]
                })
            } else {
                // its Monthly
                // select repetition "Montlhy"
                this.selectedRepetitionOption = this.repetitionOptions.find(repetitionOption => {
                    return repetitionOption.id == 2
                })

                // select day
                this.selectedMonthDayOption = this.getMonthDayOptions.find(monthDayOption => {
                    return monthDayOption.id == cronArray[2]
                })
            }
        }
    },
    components: {
        vSelect,
        Datepicker
    }
}
</script>

<style lang="css" scoped>
</style>



// WEBPACK FOOTER //
// cronConfigure.vue?c52ce45a